import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '#/renderer/router';
import { Helmet } from 'react-helmet';
import { isMobile } from 'react-device-detect';
import { filter } from 'lodash-es';

// import ModalNotification from '../../components/ui/ModalNotification';
import analytics from '~/helpers/analytics';
import { currencyFormat, imgFormat } from '~/helpers/formatter';
import prodHelper from '~/helpers/product';
import { iconQuestion } from '~/helpers/svg';
import useStores from '~/store/StoreHook';
//import blukai, removido

import ModalNotification from '~/components/ui/ModalNotification';
import ESImIndicator from '~/components/ESimIndicator/ESimIndicator';
import { SINEQUIPO, usePospagoState } from '~/store/States/pospago';

import Cross from './Cross/Cross';

export const ModalWarn = props => (
  <ModalNotification>
    <header>
      <i>{iconQuestion}</i>
      <h4>Aviso</h4>
    </header>
    <div className="cart--modal-switch_item">
      <span>{`${props.message}`}</span>
      <nav>
        <button type="button" onClick={props.closeWarn}><span>Cerrar</span></button>
      </nav>
    </div>
  </ModalNotification>
);

export const CartEmpty = () => (
  <div className="cart--empty">
    <p>Tu carrito está vacío</p>
    <Link to="/"><span>Ir a Tienda</span></Link>
  </div>
);

export const CartDetails = ({ itemInfo, qty, deleteItem, product, addOnsList, addonsListState, addonsState, cartItem, cart, item }) => {
  const { orderStore } = useStores();
  const [cartTitle, setCartTitle] = useState();
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState(0);
  const [eSimConfig, setESimConfig] = useState(null);
  const pospagoState = usePospagoState(cart.some(it => it.part_number_kit));
  const isSinEquipo = cart.some(it => it.part_number === pospagoState.config.product_sku_sin_equipo.value);

  const attrMap = prodHelper.convertAttributes(itemInfo.attributes);
  const tipo = attrMap['attr-conf-tipoproducto'];
  const recurrente = attrMap['attr-conf-pagorecurrente'];
  const tipoPlan = attrMap['attr-conf-tipoplan']?.toUpperCase() || '';
  const obligatorio = attrMap['attr-conf-obligatorio'] || '';
  const precioMensual = (isSinEquipo && attrMap['attr-conf-precio-mensual-sin-equipo']) || attrMap['attr-conf-precio-mensual'];
  const noIncluido = attrMap['attr-conf-todo-incluido']?.toUpperCase() === 'NO';
  const query = isSinEquipo ? `?tipo=${SINEQUIPO}` : '';
  const linkTo = `/product${tipo === 'OTRO' ? 'x' : tipo === 'POSPAGO' ? 'p' : ''}/${itemInfo.locales[process.env.NEXT_PUBLIC_LOCALE].seo.name}/${product}${query}`;
  let currencyText;
  let isIncluided = false;
  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      await orderStore.getConfigEsim();

      if (orderStore.getEsimConfig.success) {
        const esimConfigToSet = orderStore.getEsimConfig.data.data;
        setESimConfig(esimConfigToSet);
      }

      if (orderStore.getCartConfig.success) {
        setCartTitle(orderStore.getCartConfig.data.data.cartTitle || '');
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }
      }



    }
    init();
  }, []);
  let total;
  if (cartItem.part_number_kit) {
    const sp = cartItem.part_number_kit.split('--');
    const plan = sp[1];
    const plazo = sp[2];
    total = itemInfo.pricing.pospago[plan][plazo].offer_price;
    currencyText = currencyFormat(total, 1).split('.');
    if (currencyText && precio_minimo_incluido) {
      isIncluided = total <= precio_minimo_incluido;
    }
  } else {
    currencyText = currencyFormat(itemInfo.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price).split('.');
    if (currencyText[0] === '0' && currencyText[1] === '00' && precioMensual) {
      currencyText = currencyFormat(precioMensual, 1).split('.');
    }
  }

  const specs = (itemInfo.attributes || []).reduce((a, b, i) => {
    const index = `cart-spec-${i}`;

    if (b.identifier === 'def-capacidad' || b.identifier === 'def-color' || b.identifier === 'def-pantalla') {
      a.push(<p key={index}><span>{b.value}</span></p>);
    }

    return a;
  }, []);

  const conEsimTexto = eSimConfig && eSimConfig.cart && eSimConfig.cart.conEsim ? eSimConfig.cart.conEsim : ''

  if (item.esim) {
    specs.push(<p><span>{conEsimTexto}</span></p>)
  }

  const doDelete = () => {
    deleteItem(itemInfo.part_number, tipo, tipoPlan);
  };

  const deleteAction = obligatorio.toUpperCase() !== 'SI' && (<a className="delete" onClick={doDelete}>Eliminar del carrito</a>);
  let img = '/media/demo/claro.png';

  if (itemInfo && itemInfo.images && itemInfo.images.length) {
    img = imgFormat('210x180', `${process.env.NEXT_PUBLIC_CDN_PATH}${itemInfo.images[0]}`);
  }
  let tituloLlamadas = filter(itemInfo.attributes, { identifier: 'attr-chars-titulo-llamadas' });
  if (tituloLlamadas && tituloLlamadas.length && tituloLlamadas.length > 0) tituloLlamadas = tituloLlamadas[0].value;
  let descLlamadas = filter(itemInfo.attributes, { identifier: 'attr-chars-desc-llamadas' });
  if (descLlamadas && descLlamadas.length && descLlamadas.length > 0) descLlamadas = descLlamadas[0].value;
  let tituloMensajes = filter(itemInfo.attributes, { identifier: 'attr-chars-titulo-mensajes' });
  if (tituloMensajes && tituloMensajes.length && tituloMensajes.length > 0) tituloMensajes = tituloMensajes[0].value;
  let descMensajes = filter(itemInfo.attributes, { identifier: 'attr-chars-desc-mensajes' });
  if (descMensajes && descMensajes.length && descMensajes.length > 0) descMensajes = descMensajes[0].value;
  let tituloInternet = filter(itemInfo.attributes, { identifier: 'attr-chars-titulo-internet' });
  if (tituloInternet && tituloInternet.length && tituloInternet.length > 0) tituloInternet = tituloInternet[0].value;
  // let descInternet = filter(itemInfo.attributes, { identifier: 'attr-chars-desc-internet' });
  // if (descInternet && descInternet.length && descInternet.length > 0) descInternet = descInternet[0].value;
  let shortDescription = filter(itemInfo.attributes, { identifier: 'attr-short-description' });
  if (shortDescription && shortDescription.length && shortDescription.length > 0) shortDescription = shortDescription[0].value;
  let roamingAttr = filter(itemInfo.attributes, { identifier: 'attr-chars-main-roaming' });
  if (roamingAttr && roamingAttr.length && roamingAttr.length > 0) roamingAttr = roamingAttr[0].value;
  const redesAttr = itemInfo.attributes.filter(red => red.identifier.startsWith('attr-redsocial'));
  let musica = filter(itemInfo.attributes, { identifier: 'attr-paquete-musica' });
  if (musica && musica.length && musica.length > 0 && musica[0].value === 'SI') {
    musica = 'Claro Música incluido';
  } else {
    musica = '';
  }
  let video = filter(itemInfo.attributes, { identifier: 'attr-paquete-video' });
  if (video && video.length && video.length > 0 && video[0].value === 'SI') {
    video = 'Claro Video incluido';
  } else {
    video = '';
  }
  // let garantia = attrMap['attr-paquete-garantia'] || '';
  // if (garantia === 'SI') {
  //   garantia = 'Garantía incluida';
  // }
  let items2;
  let redesAttrInclude;
  let redesCount = 0;
  if (redesAttr.length > 0) {
    items2 = (redesAttr || []).map((v) => {
      if (v.value !== 'SI' && v.value !== 'si') return false;
      redesCount += 1;
      return <img key={`redsocial--${redesCount}`} src={`${process.env.NEXT_PUBLIC_CDN_PATH}/espots/socialmedia/${v.identifier.replace(/-/g, '_')}.jpg`} alt={v.name} style={{ maxWidth: '40px', display: 'inline-flex', paddingRight: '0.5em', maxHeight: '40px' }} />;
    });
    redesAttrInclude = itemInfo.attributes.filter(red => red.identifier.startsWith('attr-chars-main-redsocail-descripcion'));
  }

  const redesTitle = redesCount > 0 ? 'REDES SOCIALES INCLUIDAS' : '';
  const esimIndicator = eSimConfig ? eSimConfig.esimIndicator : null;
  const name = (isSinEquipo && attrMap['attr-conf-nombre-plan-sin-equipo']) || itemInfo.locales[process.env.NEXT_PUBLIC_LOCALE].name;
  const fullname = name.replace(/<br>/, '\n').replace(/<br\/>/, '\n').replace(/\\n/, '\n').split('\n')
    .map((str, idx) => <p key={`cart-title-${itemInfo.part_number}-${idx}`}>{str}</p>);
  switch (tipo) {
    case 'PREPAGO':
    case 'POSPAGO': {
      if (!addonsListState || itemInfo.part_number === pospagoState.config.product_sku_sin_equipo.value) return null;
      let first = true;
      const addOns = (addOnsList || []).map((data, idx) => {
        if (first) {
          first = false;
          return <p key={`addon-${idx}`}>{ data.description }</p>;
        } else {
          return <div key={`addon-${idx}`}><br /><p>{ data.description }</p></div>;
        }
      });
      const addOnsPrice = (addOnsList || []).map((data, idx) => {
        const subtotal = (data.price * data.quantity).toFixed(2).toString().replace('.', '');
        const tot = currencyFormat(subtotal).split('.');
        return <div key={`addons-price-${idx}`}><p className="price"><span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span><span>{tot[0]}.</span><span className="symbol">{String(tot[1]).padStart(2, '0')}</span></p></div>;
      });

      const addOnsSection = (
        <section className="cart--detail">
          <header>
            <h3>Adicional</h3>
            {addOns}
          </header>
          <section>
            <h2>Precio</h2>
            {addOnsPrice}
          </section>
        </section>
      );
      return (
        <section className="cart--content">
          <article className="cart--box">
            <section className="cart--image">
              <Link to={linkTo} className="cart--image-link" style={{ position: 'relative' }}>
                <div>
                {fullname}
                </div>
                {
                  item.esim && (
                    <ESImIndicator customStyles={{ position: 'unset', marginLeft: '-12px', marginTop: '12px' }} label={esimIndicator?.label} image={esimIndicator?.image} />
                  )
                }
                <picture>
                  <img src={img} alt="alt" />
                </picture>
              </Link>
              {deleteAction}
            </section>
            <section className="cart--description">
              {isMobile
                && (
                  <section className="cart--header-detail">
                    <h2>Descripción</h2>
                    <h2>Precio</h2>
                  </section>
                )}
              <section className="cart--head">
                <header>
                  <h3>{cartTitle || 'Resumen de tu cel'}</h3>
                  <Link to={linkTo}>{fullname}</Link>
                  {specs}
                </header>
                <section>
                  {isIncluided
                    ? <p className="price" style={{ fontSize: '1.5rem' }}><span>INCLUIDO</span></p>
                    : (
                      <p className="price">
                        <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                        <span>{currencyText[0]}.</span>
                        <span className="symbol">{currencyText[1]}</span>
                        { recurrente === 'SI' ? <span className="recurrency">/mes</span> : '' }
                      </p>
                    )}
                </section>
              </section>
              {addOnsList.length !== 0 && addonsState ? addOnsSection : null}
              <section className="cart--detail">
                <header>
                  <h3>Envío</h3>
                  <p>Normal</p>
                </header>
                <section>
                  <p className="price">
                    <span>GRATIS</span>
                  </p>
                </section>
              </section>
            </section>
          </article>
        </section>
      );
    }
    case 'PLAN':
      if (tipoPlan === 'FIJO' && noIncluido) {
        const kitItem = cart.find(it => it.part_number_kit);
        if (kitItem) {
          const sp = kitItem.part_number_kit.split('--');
          const plan = sp[1];
          const plazo = sp[2];
          currencyText = currencyFormat(((kitItem.product.items[0].pricing.pospago[plan][plazo].financing || 0) / plazo) + +precioMensual, 1).split('.');
        }
      }

      const planItem = cart.find(it => it.part_number_kit) ? cart.find(it => it.part_number_kit) : {};

      const  tipoPostpago =  attrMap['attr-tipo-postpago'];
      const sinEquipo = tipoPostpago === 'SINEQUIPO' || planItem?.part_number === "K01_0001_001";

      return (
        <section className="cart--content">
          <article className="cart--box">
            <section className="cart--image">
              <Link to={linkTo} className="cart--image-link">
                {fullname}
                <picture>
                  <img src={img} alt="alt" />
                </picture>
              </Link>
              {deleteAction}
            </section>
            <section className="cart--description">
              <section className="cart--head">
                {isMobile
                  ? (
                    <section className="cart--header-detail">
                      <h2>Descripción</h2>
                      <h2>Precio</h2>
                    </section>
                  ) : ''}
                <header>
                  <h3>Resumen del plan</h3>
                  {/* <Link to={linkTo}>{itemInfo.locales[process.env.NEXT_PUBLIC_LOCALE].name}</Link> */}
                  <p>{tituloLlamadas}</p>
                  <p>{descLlamadas}</p>
                  <p>{tituloMensajes}</p>
                  <p>{descMensajes}</p>
                  <p>{tituloInternet}</p>
                  {/* <p>{descInternet}</p> */}
                  {roamingAttr && <p>{roamingAttr}</p>}
                  {musica && <p>{musica}</p>}
                  {video && <p>{video}</p>}
                  {(sinEquipo && planItem?.esim) &&<p>{conEsimTexto}</p>}
                  <div>
                    <div className="p block"><h3 className="subtitle">{redesTitle}</h3></div>
                    <section className="cart--head-redes-sociales" style={{ width: 'auto' }}>
                      {items2}
                    </section>
                    <p className="cart--head-p">{redesAttrInclude[0].value}</p>
                  </div>
                  {specs}
                  {/* <p>{shortDescription}</p> */}
                </header>
                <section>
                  <p className="price">
                    <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                    <span>{currencyText[0]}.</span>
                    <span className="symbol">{currencyText[1]}</span>
                    { recurrente === 'SI' ? <span className="recurrency">/mes</span> : '' }
                  </p>
                </section>
              </section>
            </section>
          </article>
        </section>
      );
    case 'ADDONS':
      return (
        <section className="cart--content">
          <article className="cart--box">
            <section className="cart--image">
              <Link to={linkTo} className="cart--image-link">
                {fullname}
                <picture>
                  <img src={img} alt="alt" />
                </picture>
              </Link>
              {deleteAction}
            </section>
            <section className="cart--description">
              <section className="cart--head">
                {isMobile
                  ? (
                    <section className="cart--header-detail">
                      <h2>Descripción</h2>
                      <h2>Precio</h2>
                    </section>
                  ) : ''}
                <header>
                  <h3>Resumen del Add-ons</h3>
                  <Link to={linkTo}>{fullname}</Link>
                  <p>{shortDescription}</p>
                  {specs}
                </header>
                <section>
                  <p className="price">
                    <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                    <span>{currencyText[0]}.</span>
                    <span className="symbol">{currencyText[1]}</span>
                    { recurrente === 'SI' ? <span className="recurrency"> /1er pago</span> : '' }
                  </p>
                </section>
              </section>
            </section>
          </article>
        </section>
      );
    case 'OTRO':
      return (
        <section className="cart--content">
          <article className="cart--box">
            <section className="cart--image">
              <Link to={linkTo} className="cart--image-link">
                {fullname}
                <picture>
                  <img src={img} alt="alt" />
                </picture>
              </Link>
              {deleteAction}
            </section>
            <section className="cart--description">
              <section className="cart--head">
                {isMobile
                  ? (
                    <section className="cart--header-detail">
                      <h2>Descripción</h2>
                      <h2>Precio</h2>
                    </section>
                  ) : ''}
                <header>
                  <h3>Resumen de tu equipo</h3>
                  <Link to={linkTo}>{fullname} {qty > 1 ? `(${qty})` : null }</Link>
                  {specs}
                </header>
                <section>
                  <p className="price">
                    <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                    <span>{currencyText[0]}.</span>
                    <span className="symbol">{currencyText[1]}</span>
                    { recurrente === 'SI' ? <span className="recurrency"> /1er pago</span> : '' }
                  </p>
                </section>
              </section>
              <section className="cart--detail">
                <header>
                  <h3>Envío</h3>
                  <p>Normal</p>
                </header>
                <section>
                  <p className="price">
                    <span>GRATIS</span>
                  </p>
                </section>
              </section>
            </section>
          </article>
        </section>
      );
    case 'GARANTIA':
      return (
        <section className="cart--content">
          <article className="cart--box">
            <section className="cart--image">
              <Link to={linkTo} className="cart--image-link">
                {fullname}
                <picture>
                  <img src={img} alt="alt" />
                </picture>
              </Link>
              {deleteAction}
            </section>
            <section className="cart--description">
              <section className="cart--head">
                {isMobile
                  ? (
                    <section className="cart--header-detail">
                      <h2>Descripción</h2>
                      <h2>Precio</h2>
                    </section>
                  ) : ''}
                <header>
                  <h3>Resumen</h3>
                  <Link to={linkTo}>{fullname}</Link>
                  <p>{shortDescription}</p>
                  {specs}
                </header>
                <section>
                  <p className="price">
                    <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                    <span>{currencyText[0]}.</span>
                    <span className="symbol">{currencyText[1]}</span>
                    { recurrente === 'SI' ? <span className="recurrency"> /mes</span> : '' }
                  </p>
                </section>
              </section>
            </section>
          </article>
        </section>
      );
    default:
      return null;
  }
};

// checkoutRedirect
const UI = ({ cartInfo, isEmpty, checkoutRedirect, deleteItem, cardMessageErrorProp, addOnsList, addonsListState, tipo, addToCart, warnMessage, closeWarn }) => {
  const { orderStore } = useStores();
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState(0);
  let showing = false;
  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }
      }
    }
    init();
  }, []);

  if (!addonsListState) return null;
  const itemInfo = {};
  const iconWarning = '/media/layout/warning.png';
  // const cartWarning = (<p>Para información sobre restricciones de compra ingresa <Link to="/terms#restricciones" target="_blank" rel="noopener noreferrer">aquí</Link></p>);
  let addonsState = false;
  const cartItems = (cartInfo.items || [])
    .filter((data) => {
      if (addOnsList.some(ad => ad.item_part_number === data.part_number)) {
        addonsState = true;
        return false;
      }
      return true;
    });
  const cartDetails = cartItems
    .map((data, i) => {
      const index = `item--${data.part_number}--${i}`;
      // item dictionary info.
      const productPartNumber = data.product.part_number;
      (data.product.items).map((items) => {
        itemInfo[items.part_number] = items;
        return items;
      });

      return (
        <CartDetails
          key={index}
          item={data}
          itemInfo={itemInfo[data.part_number]}
          qty={+data.quantity}
          deleteItem={deleteItem}
          product={productPartNumber}
          addOnsList={addOnsList}
          addonsListState={addonsListState}
          addonsState={addonsState}
          cartItem={data}
          cart={cartItems}>
        </CartDetails>
      );
    });

  let grandTotal;
  let total;
  if (cartInfo && cartInfo.amount && cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY]) {
    grandTotal = cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY].grand_total;
    grandTotal = currencyFormat(grandTotal).split('.');
    const centsTemp = parseInt(grandTotal[1], 10);
    grandTotal[1] = centsTemp < 100 ? centsTemp : centsTemp - 100;

    if (precio_minimo_incluido) {
      const amount = grandTotal ? grandTotal[0] : '';
      const decimals = grandTotal ? String(grandTotal[1]).padStart(2, '0') : '';

      total = `${amount}.${decimals}`;
      total = parseFloat(total);
      showing = total <= precio_minimo_incluido;
    }
  }
  let cardMessageError = '';
  if (cardMessageErrorProp && cardMessageErrorProp.errorKey && cardMessageErrorProp.errorKey === '_API_BAD_INV') {
    const partNumber = cardMessageErrorProp.errorParameters.split(',');
    cardMessageError = (<p><span>No hay suficiente inventario para adquirir el producto <b>{partNumber[0]}</b></span></p>);
  }

  return (
    <main>
      <Helmet title={`Carrito de Compra | Tienda Claro ${process.env.NEXT_PUBLIC_COUNTRY}`} />
      { isEmpty ? <CartEmpty />
        : (
          <section className="cart">
            <header className="cart--header">
              <h1 style={{ fontSize: '' }}>CARRITO DE COMPRA</h1>
            </header>
            {
          (cardMessageError !== ''
            ? (
              <div className="cart--warning">
                <img src={iconWarning} alt="warning" />
                {cardMessageError}
              </div>
            )
            : cardMessageError)
        }
            {!isMobile
              ? (
                <section className="cart--header-detail">
                  <h2>Descripción</h2>
                  <h2>Precio</h2>
                </section>
              ) : ''}
            {cartDetails}
            {!showing && (
              <section className="cart--total">
                <section>
                  <b>TOTAL:</b>
                  <p>
                    <span>{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                    <span>{grandTotal ? grandTotal[0] : ''}.</span>
                    <span className="symbol">{grandTotal ? String(grandTotal[1]).padStart(2, '0') : ''}</span>
                  </p>
                </section>
              </section>
            )}
            { tipo && <Cross tipo={tipo} addToCart={addToCart} cartItems={cartInfo.items} /> }
            <footer className="cart--footer">
            <Link to="/" id="seguir-comprando" onClick={()=>{
              //blukai function, removida
              }}>
                <span>Seguir comprando</span>
              </Link>
              {checkoutRedirect}
            </footer>
            {/* <div className="cart--warning">
              <img src={iconWarning} alt="warning" />
              {cartWarning}
            </div> */}
            { warnMessage ? <ModalWarn message={warnMessage} closeWarn={closeWarn} /> : null }
          </section>
        )}
    </main>
  );
};

UI.propTypes = {
  cartInfo: PropTypes.shape({}),
  isEmpty: PropTypes.bool.isRequired,
  checkoutRedirect: PropTypes.node,
};

UI.defaultProps = {
  cartInfo: {},
  checkoutRedirect: '',
};

CartDetails.propTypes = {
  itemInfo: PropTypes.shape({}),
  product: PropTypes.string.isRequired,
};

CartDetails.defaultProps = {
  itemInfo: {},
};

export default UI;
